import React, { useEffect, useState } from 'react';
import Table from '../../../components/Table/Table';
import _, { get as LodashGet } from 'lodash';
import myClasses from '../../SmartCharging/SmartCharging.module.css';
import Typography from '../../../components/Typography/Typography';
import { useLoader } from '../../../hooks';
import { toast } from 'react-toastify';
import { EventsService } from '../../../services/EventsService';
import { momentTimeFormater } from '../../../utils/dateHelper';
import CustomTooltip from '../../../components/CustomToolTip/CustomTooltip';
import classes from '../../../styles/AllDevices.module.css';

const CommandLogsModal = ({ setOpen, id = '' }) => {
    const [startLoader, stopLoader] = useLoader();

    const [data, setData] = useState([]);

    useEffect(() => {
        getLogs();
    }, [id]);

    const getLogs = () => {
        if (id) {
            EventsService.GetCommandLogs(id, startLoader, handleSuccess, handleError, stopLoader);
        }
    };

    const handleSuccess = ({ data }) => {
        const processedData = _.get(data, ['data'], []).map((item) => {
            const request = item.write?.value;
            const reply = item.reply?.value;
            return {
                setPoint: request.setPoint,
                status: request.status,
                activationDirection: request.activationDirection,
                replyResponse: reply?.response ? reply.response : '--',
                commandId:
                    !request.commandId ? (
                        '--'
                    ) : request.commandId.length > 70 ? (
                        <CustomTooltip content={`${request?.commandId}`}>{request?.commandId.substring(0, 70) + '...'}</CustomTooltip>
                    ) : (
                        `${request?.commandId}`
                    ),
                writeTimestamp: request.timestamp ? momentTimeFormater(request.timestamp).format('YYYY-MM-DD HH:mm:ss') : '--',
                replyTimestamp: reply?.timestamp ? momentTimeFormater(reply.timestamp).format('YYYY-MM-DD HH:mm:ss') : '--',
            }
        });
        setData(processedData);
    };

    const handleError = (err) => {
        let data = err && err.response ? err.response.data : null;
        if (data) toast.error(data.message);
        else toast.error('Internal server error!');
    };

    return (
        <div style={{ minWidth: '80vw', maxHeight: '90vh', overflowY: 'scroll' }}>
            <div className={myClasses.wholeFilterWrapper}>
                <div className={myClasses.HeadingContainer}>
                    <Typography content={`Command Logs`} />
                    <div className={classes.TableCount}>
                        Total Count :
                        <span>
                            <Typography size="14" content={data.length} />
                        </span>
                    </div>
                </div>
            </div>
            <Table
                head={['SET POINT', 'STATUS', 'ACTIVATION DIRECTION', 'REPLY RESPONSE', 'COMMAND ID', 'WRITE TIMESTAMP (CET)', 'REPLY TIMESTAMP (CET)']}
                keys={['setPoint', 'status', 'activationDirection', 'replyResponse', 'commandId', 'writeTimestamp', 'replyTimestamp']}
                data={data}
            />
            <div className={myClasses.ButtonContainer}>
                <div className="btn-secondary" onClick={setOpen}>
                    Close
                </div>
            </div>
        </div>
    );
};

export default CommandLogsModal;
